import {replace, split, size} from 'lodash/fp';
import {flow, at, orElse} from 'ts-opt';

const decimalPartIndex = 1;

/**
 * Counts the digits after the decimal separator in a numeric string.
 *
 * @param inputString - The string to inspect.
 * @returns The number of decimal places.
 */
export const countDecimalPlaces: (inputString: string) => number = flow(
    replace(',', '.'),
    split('.'),
    at(decimalPartIndex),
    orElse(''),
    size,
);
